import { Component, OnInit } from '@angular/core';
import { BackendService } from '../shared/backend.service';
import CONFIG from '../config';
import { PaginationService } from '../shared/pagination.service';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { OrderByService } from '../shared/orderby.service';
import { AlertmessageService } from '../shared/alertmessage.service';
import { SearchService } from '../shared/search.service';

@Component({
  selector: 'app-adminaccess',
  templateUrl: './adminaccess.component.html',
  styleUrls: ['./adminaccess.component.scss'],
  providers: [PaginationService, OrderByService,SearchService],
})
export class AdminaccessComponent implements OnInit {

  TextSearch:FormGroup;
  term:FormControl;
  loadingData: boolean = false;
  entryRange: Array<number>;
  originalItems: Object[] = [];
  totalEntries: number = 0;
  pagenlenth: boolean = true;
  audit: Object[] = [];
  noEntrys: boolean = false;
  entryRangeSubscription: Subscription;
  defaultSortOrder: string = '';
  items:any;
  searchArray: Array<string> = [];
  searchFilteredItems: Object[] = [];
  getData11: any;
  result: string = '';
  exportItems: Object[] = [];
  IncludeBTransNos: boolean = true;
  active: string = '';
  bankid:any;
  constructor( public _backendservice:BackendService,
    public _paginationService:PaginationService,
    public _formBuilder:FormBuilder,
    public orderByService: OrderByService,
    public alert:AlertmessageService,
    public searchService: SearchService,) { }

  ngOnInit() {
    this. pageLoad();
    this.searchArray = ['bankid' ];
    this.TextSearch=this._formBuilder.group({
      'term': ['',],
    
    })

  }

  btnUpdate(Record)
  {
    console.log(Record);

    this._backendservice.postData(Record,`${CONFIG.loginSessionActivityApiUrlBase}/update`)
    .subscribe(response => {
      if (response) {
        //this.setForm();
        this.alert.openConfirmationDialogLong1(response['msg']);;
       
       // this.getbankIdDropdown();
      // this.getSubmissions();
      //this.loadingData = true;
      //this.filterbyStatus();
     //this.refresh()
      }
      else {
        this.alert.openConfirmationDialogLong(response['msg']);;
        //this.getSubmissions();
       // this.loadingData = true;
      // this.refresh()
      }

    });
  }

  chSelectedDateTransactions(value,item) {
    console.log(item)

    this.IncludeBTransNos = value.checked;
    console.log(this.IncludeBTransNos);
this.bankid=item.bankid;

    this._backendservice.postData("Test",`${CONFIG.loginSessionActivityApiUrlBase}/update/${this.bankid}/${this.IncludeBTransNos}`)
    .subscribe(response => {
      if (response) {
        //this.setForm();
        this.alert.openConfirmationDialogLong1(response['msg']);;
        this.pageLoad();
       // this.getbankIdDropdown();
      // this.getSubmissions();
      //this.loadingData = true;
      //this.filterbyStatus();
     //this.refresh()
      }
      else {
        this.alert.openConfirmationDialogLong(response['msg']);;
        //this.getSubmissions();
       // this.loadingData = true;
      // this.refresh()
      }

    });






  }
  makeActive(item) {
    this.active = this.active === item ? '' : item;
}

  searchText() {
    this.result = this.TextSearch.controls['term'].value;
   console.log(this.result);
   console.log(this.originalItems);
    let itemsToSearch = this.originalItems;
    this.searchService.findItemsFromMultiple(this.result, itemsToSearch, this.searchArray)
      .then(allFiltered => {
        if (this.result.length > 0) {
      console.log("Test");
          this.audit = allFiltered;
          this.searchFilteredItems = allFiltered;
        }
        else {
          console.log("Test2")
          this.audit = this.originalItems;
          this.searchFilteredItems = this.originalItems;
        }
  
        //this.pagenlenth = false;
        this.setGrid(1, this.audit.length, "search");
        this.entryRangeSubscription = this._paginationService.entryRange
          .subscribe(range => {
            this.entryRange = range;
            this.audit = this.searchFilteredItems.slice(this.entryRange[0], this.entryRange[1]);
            this.exportItems = this.originalItems;
            this.totalEntries = this.audit.length;
          });
      });
  }

  pageLoad() {
    this._backendservice.getData( `${CONFIG.loginSessionActivityApiUrlBase}`)
      .subscribe(
        response => {
          this.loadingData = true;
          console.log(response);

      //   this.formatDataexport(response['data']);
     this.originalItems=response['getdata'];

     this.getData11 = response['getdata'];
     //this.displaygrid();
  
     for (let j = 0; j < this.getData11.length; j++) {
    //  console.log("Test 2")
     if (this.getData11[j].requirement == true) {
       //console.log(this.getData[i].requirement, this.getFileData[j].documentType);
       this.getData11[j].loginSession = true;
       this.audit=this.getData11[j].loginSession;
     }
   
 }


     this.audit = this.originalItems;
      // console.log(this.audit);
        this.totalEntries = this.audit.length;
      
        if (this.audit.length === 0) {
           this.noEntrys = true;
         }
        this.setGrid(1, this.totalEntries, "Getdata");
     
         this.paginationGrid();
        },)
        
      
      }



      displaygrid() {
        //console.log("Test")
        console.log(this.getData11.length);
           
              console.log("Test 1")
              for (let j = 0; j < this.getData11.length; j++) {
                 console.log("Test 2")
                if (this.getData11[j].requirement == true) {
                  //console.log(this.getData[i].requirement, this.getFileData[j].documentType);
                  this.getData11[j].loginSession = true;
                  this.audit=this.getData11[j].loginSession;
                }
              
            }
        
        
          }




      setGrid(start: number, length?: number, value?: string) {
        // console.log(length);
        const sentLen = length;
        this.pagenlenth = false;
        this._paginationService.setGrid(start, sentLen);
      }
      paginationGrid() {

        this.entryRangeSubscription = this._paginationService.entryRange.subscribe(range => {
        this.entryRange = range;
        this.audit = this.originalItems.slice(this.entryRange[0], this.entryRange[1]);
        ////console.log(this.audit);
        this.totalEntries = this.audit.length;
        ////console.log(this. totalEntries );
        ////console.log(this. audit );
    
      });
    }
    

    orderBy(param){
      let itemsToOrder = this.originalItems;
     //// console.log(itemsToOrder);
      const altParam = param === this.defaultSortOrder ? undefined : this.defaultSortOrder;
      // if(this.filterApplied && !this.term.value) {
      //     itemsToOrder = this.prefilteredItems;
      // } else if(this.term.value) {
      //     itemsToOrder = this.searchFilteredItems;
      // }
      this.audit = this.orderByService.orderByParam(param, itemsToOrder, altParam);
     //// console.log(this.items);
      this.setGrid(1, itemsToOrder.length);
    }


}
